export default "__VITE_ASSET__MOyYiIhN__"